import { render, staticRenderFns } from "./AudioPlayerLead.vue?vue&type=template&id=35ed8824&scoped=true"
import script from "./AudioPlayerLead.vue?vue&type=script&lang=ts"
export * from "./AudioPlayerLead.vue?vue&type=script&lang=ts"
import style0 from "./AudioPlayerLead.vue?vue&type=style&index=0&id=35ed8824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed8824",
  null
  
)

export default component.exports